(() => {
  console.log('training-sneaker-warning.js loaded');

  const MODAL_ID = 'training-sneaker-modal';

  function openModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) {
      console.warn('Training sneaker modal not found');
      return;
    }

    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    const okBtn = modal.querySelector('[data-training-sneaker-ok]');
    if (okBtn) okBtn.focus();

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      modal.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeydown);
    }

    function handleClick(e) {
      if (e.target.matches('[data-training-sneaker-ok]')) {
        closeModal();
      }
    }

    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
      }
    }

    modal.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
  }

  function initTrainingSneakerWarning() {
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.ajax-submit');
      if (!button) return;

      const form = button.closest('form');
      if (!form) return;

      if (form.dataset.trainingSneakerWarning !== 'true') return;

      console.log('Training sneaker add-to-cart clicked');

      // Let Turbo do its normal AJAX cart add.
      // We only show the modal after the click.
      setTimeout(() => {
        openModal();
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrainingSneakerWarning);
  } else {
    initTrainingSneakerWarning();
  }
})();